module.exports = __webpack_public_path__ + "img/logName.32359ad3.png";